import { useMemo } from 'react';

import { useBrand } from '@/shared/hooks/useBrand/useBrand';

import { type SidebarFootLogic, type SidebarFootProps } from './SidebarFoot.types';

/**
 * The rail's foot: who runs this deployment and how to reach them (P28).
 *
 * Every line is a `brand.*` fact and every one may be empty — an unconfigured
 * deployment shows no block rather than three empty rows, and the collapsed
 * rail has no room for prose at all.
 */
export function useSidebarFootLogic({ isCollapsed }: SidebarFootProps): SidebarFootLogic {
  const { legalEntity, supportEmail, links } = useBrand();

  return useMemo(() => {
    const entries = Object.entries(links).map(([label, href]) => ({ label, href }));
    const hasFact = legalEntity.name !== '' || supportEmail !== '' || entries.length > 0;

    return {
      isShown: !isCollapsed && hasFact,
      legalEntityName: legalEntity.name,
      supportHref: supportEmail === '' ? null : `mailto:${supportEmail}`,
      supportEmail,
      links: entries,
    };
  }, [isCollapsed, legalEntity.name, supportEmail, links]);
}
